import { Outlet, Route, useLocation, useNavigate } from 'react-router'
import React, { Suspense, useEffect } from 'react'
import { IS_INTEGRATED_VERSION } from '../../config/ConfigManager'
import { Translate } from 'common'
import { useUserStore } from '../../store/user/UserStore'
import { AppLoader } from './AppLoader'

export const PublicLayout: React.FC<
  React.ComponentProps<typeof Route>
> = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const userStore = useUserStore()

  useEffect(() => {
    // If the user is logged in, redirected to home.
    if (
      userStore.userHasLoaded &&
      userStore.preferences.userId &&
      location.pathname !== '/auto-login'
    ) {
      navigate('/home')
    }
  }, [
    location.pathname,
    navigate,
    userStore.preferences.userId,
    userStore.userHasLoaded,
  ])

  if (IS_INTEGRATED_VERSION) {
    return <>{Translate('invalidCredentials')}</>
  }

  if (!userStore.userHasLoaded) {
    return <AppLoader />
  }

  return (
    <Suspense fallback={<AppLoader />}>
      <Outlet />
    </Suspense>
  )
}
